//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import LinkBtn from '../../../components/LinkBtn.vue'
import RequestMapPopup from '../../Request/RequestMapPopup/RequestMapPopup.vue'
import Comments from '../../../components/Comments/Comments.vue'
import DispatcherServiceObjectsTabCreateRequests from '../../../pages/main/sections/Dispatcher/DispatcherTab/DispatcherServiceObjectsTabCreateRequests.vue'
import ServiceObjectZabbixMonitoringStatus from '../ServiceObjectZabbixMonitoringStatus.vue'
import ServiceObjectConductorConnectionStatus from '../ServiceObjectConductorConnectionStatus.vue'

export default {
  components: {
    LinkBtn,
    RequestMapPopup,
    Comments,
    ServiceObjectZabbixMonitoringStatus,
    ServiceObjectConductorConnectionStatus,
    DispatcherServiceObjectsTabCreateRequests
  },
  props: {
    requestsIds: {
      type: Array,
      default () {
        return []
      }
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      selectedTab: 'map',
      selectedRequest: null,
      createRequestsOpened: false,
      requests: [],
      recentRequests: [],
      sortBy: 'priority'
    }
  },
  computed: {
    roleDispatcherOrHigher: function () {
      const user = this.$store.getters.getUser
      const roles = user.roles || {}
      return !!roles.root || !!roles.admin || !!roles.dispatcher
    },
    isContractor: function () {
      const user = this.$store.getters.getUser
      return !!(user && user.employee && user.employee.isContractor)
    },
    externalEmployee: function () {
      const user = this.$store.getters.getUser
      return !!(user.employee && user.employee.external && !user.isContractor)
    },
    externalDispatcher: function () {
      if (this.externalEmployee) {
        const user = this.$store.getters.getUser
        return user.hasRoleStrict('dispatcher') || user.hasRoleStrict('externalDispatcher')
      }
      return true
    },
    externalDispatcherBounded: function () {
      const user = this.$store.getters.getUser
      return user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')
    },
    displayControllerTypeField: function () {
      return !this.externalDispatcherBounded
    },
    displayAddTaskButton: function () {
      return this.roleDispatcherOrHigher || this.externalDispatcher
    }
  },
  watch: {
    sortBy: function () {
      this.sortRequests()
      localStorage.setItem('serviceObjectMapPopupRequestsSortBy', this.sortBy)
    },
    requestsIds: {
      handler: async function () {
        if (this.serviceObject && this.serviceObject.recentRequests) {
          this.recentRequests = await this.getRequests(this.serviceObject.recentRequests.map(r => r.id))
        }
        this.requests = await this.getRequests(this.requestsIds)

        this.sortRequests()
      },
      immediate: true
    }
  },
  created: async function () {
    const sortBy = localStorage.getItem('serviceObjectMapPopupRequestsSortBy')
    if (sortBy === 'closeConditionTime' || sortBy === 'priotity') {
      this.sortBy = sortBy
    }
  },
  methods: {
    handleRequestUpdate (index, updatedRequest, requests) {
      requests[index].requestPriority = updatedRequest.requestPriority
      requests[index].closeConditionTime = updatedRequest.closeConditionTime
      this.sortRequests()
    },
    sortRequests: function () {
      const sort = requests => {
        if (this.sortBy === 'priority') {
          return requests.sort((a, b) => {
            const priorityA = a.requestPriority || a.executionPriority
            const priorityB = b.requestPriority || b.executionPriority
            return priorityB - priorityA
          })
        } else if (this.sortBy === 'closeConditionTime') {
          return requests.sort((a, b) => {
            if (a.closeConditionTime == null && b.closeConditionTime == null) {
              return 0
            }
            if (a.closeConditionTime == null) {
              return 1
            }
            if (b.closeConditionTime == null) {
              return -1
            }
            return a.closeConditionTime - b.closeConditionTime
          })
        } else {
          return requests
        }
      }

      this.requests = sort(this.requests)
      this.recentRequests = sort(this.recentRequests)
    },
    getRequests: function (ids) {
      this.loading = true
      return axiosGet({
        url: '/service/delta/request/getRequests?id=' + ids.toString(),
        onSuccess: (response) => {
          const requestsData = response.data.result
          return requestsData
        },
        onFailure: 'Ошибка загрузки информации по заявкам'
      }).finally(() => {
        this.loading = false
      })
    },
    onSelectRequest: function (request) {
      const sameRequest = this.selectedRequest != null && this.selectedRequest.requestId === request.requestId
      if (sameRequest) {
        this.selectedRequest = null
      } else {
        this.selectedRequest = request
      }

      const dialog = this.$parent.$parent.$parent.$parent.$refs.requestsListDialog
      if (dialog) {
        if (sameRequest) {
          dialog.close()
        } else {
          dialog.show(request.closeRequests.map(otherRequest => otherRequest.id), 'Ближайшие заявки по времени создания')
        }
      }
    },
    openAddressInYandexMaps: function () {
      const url = this.$d.getYandexMapsLocationUrl(this.serviceObject.location)
      if (url) {
        window.open(url, '_blank')
      }
    },
    openIpAddress: function () {
      if (this.serviceObject.deviceIp && this.serviceObject.deviceIp !== 'Нет данных') {
        window.open('http://' + this.serviceObject.deviceIp.split(', ')[0])
      }
    }
  }
}

